import React from 'react';
import SectionTitle from "../layout/SectionTitle";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function Chiffres() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const stats = [
    {
      value: 2000,
      unit: "",
      label: t('home.chiffres.parcelles'),
      description: t('home.chiffres.parcellesLabel')
    },
    {
      value: "02",
      unit: "",
      label: t('home.chiffres.filiales'),
      description: t('home.chiffres.filialesLabel')
    },
    {
      value: 150,
      unit: "",
      label: t('home.chiffres.collaborateurs'),
      description: t('home.chiffres.collaborateursLabel')
    },
    {
      value: 200,
      unit: "",
      label: t('home.chiffres.voiries'),
      description: t('home.chiffres.voiries')
    },
    {
      value: 100,
      unit: "",
      label: t('home.chiffres.patrimoine'),
      description: t('home.chiffres.patrimoineLabel')
    },
  ];

  return (
    <section className="py-6 bg-white">
      <div className="container mx-auto px-2 sm:px-3">
        <SectionTitle 
          overline={t("home.chiffres.title")}
          highlight={t("home.chiffres.highlight")}
          showLogo={true}
        />

        {/* Chiffres clés */}
        <div
          ref={ref}
          className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1 sm:gap-2 md:gap-3 lg:gap-4 text-center mt-6"
        >
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              className={`flex flex-col items-center px-0 py-1 sm:py-2 md:py-3 rounded-md relative`}
              initial={{ opacity: 0, y: 30, scale: 0.9 }}
              animate={inView ? { opacity: 1, y: 0, scale: 1 } : {}}
              transition={{ 
                delay: i * 0.2, 
                duration: 0.7, 
                type: 'spring', 
                stiffness: 80 
              }}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Fond animé au survol */}
              <motion.div 
                className="absolute inset-0 bg-white rounded-md z-0"
                animate={{
                  scale: hoveredIndex === i ? 1.05 : 1,
                  boxShadow: hoveredIndex === i ? '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' : '0 0 0 0 rgba(0, 0, 0, 0)',
                }}
                transition={{ duration: 0.3 }}
              />
              
              {/* Contenu */}
              <motion.div 
                className="text-socabeg-red text-3xl sm:text-4xl md:text-5xl font-bold relative z-10 mb-0"
                animate={{
                  scale: hoveredIndex === i ? 1.1 : 1,
                }}
                transition={{ duration: 0.3 }}
              >
                <div className="flex flex-col items-center">
                  <span className="whitespace-nowrap inline-flex items-baseline">
                    {i !== 1 && <span className="inline-block mr-0.5">+</span>}
                    {typeof stat.value === 'string' ? (
                      <span className="inline-block">{stat.value}</span>
                    ) : (
                      <CountUp 
                        start={0}
                        end={stat.value} 
                        duration={5}
                        separator="," 
                        delay={i * 0.3}
                        className="inline-block"
                        enableScrollSpy
                        decimals={0}
                        useEasing={true}
                      />
                    )}
                    {stat.unit && (
                      <span className="text-black ml-1 text-sm md:text-base">{stat.unit}</span>
                    )}
                  </span>
                </div>
              </motion.div>
              
              {/* Séparateur supprimé */}
              
              <motion.div 
                className="text-[9px] xs:text-[10px] sm:text-xs text-socabeg-dark-gray font-medium mt-3 text-center relative z-10 mx-auto w-full h-[32px] flex flex-col justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: inView ? 1 : 0 }}
                transition={{ delay: i * 0.2 + 0.7, duration: 0.5 }}
              >
                <div className="mb-1">{stat.description.split('\n')[0]}</div>
                <div>{stat.description.split('\n')[1] || ''}</div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
